<template>
  <div v-if="show" class="tarifario-form-wrapper pa-2">
    <!-- Encabezado / Estado -->
    <div class="mb-4 d-flex align-center justify-space-between flex-wrap">
      <div>
        <h4 class="m-0 font-weight-bold text-subtitle-1">
          {{ edit ? 'Editar Tarifario' : 'Nuevo Tarifario' }}
        </h4>
        <span class="text-caption text-muted">
          {{ edit ? 'Actualice la configuración del tarifario seleccionado'
            : 'Configure el nombre y las agencias con acceso a este tarifario' }}
        </span>
      </div>
      <v-chip small :color="edit ? 'blue lighten-5' : 'green lighten-5'"
        :class="edit ? 'blue--text text--darken-3 font-weight-medium' : 'green--text text--darken-3 font-weight-medium'">
        <i :class="edit ? 'lni lni-pencil mr-1' : 'lni lni-plus mr-1'"></i>
        {{ edit ? 'Edición' : 'Nuevo' }}
      </v-chip>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="checkForm">
      <v-row dense>
        <!-- Nombre del Tarifario -->
        <v-col cols="12" class="mb-2">
          <label class="form-label font-weight-medium text-caption text--secondary mb-1 d-block">
            Nombre del Tarifario <span class="text-danger">*</span>
          </label>
          <v-text-field v-model.trim="Nombre" placeholder="Ej. Tarifario General / Agencias Mayoristas"
            :rules="rules.name" outlined dense clearable hide-details="auto"></v-text-field>
          <v-autocomplete v-model="Segmento" outlined dense label="Segmento de tarifa (Opcional)" class="mt-4"
            :items="segmentosReserva" item-value="id" item-text="nm" clearable></v-autocomplete>
          <v-autocomplete v-model="Mercado" outlined dense label="Mercado (Opcional)" class="mt-4"
            :items="mercadosReserva" item-value="id" item-text="nm" clearable placeholder="Seleccionar mercado"></v-autocomplete>
        </v-col>

        <!-- Tarjeta de Cobertura y Acceso de Agencias -->
        <v-col cols="12" class="mb-2">
          <div class="access-card pa-3 rounded-lg">
            <div class="d-flex align-center justify-space-between">
              <div class="mr-3">
                <div class="d-flex align-center">
                  <i class="lni lni-network text-primary mr-1"></i>
                  <span class="font-weight-medium text-body-2">Todas las agencias</span>
                </div>
                <div class="text-caption text-muted">
                  Habilita el tarifario para todos los canales y agencias disponibles
                </div>
              </div>
              <v-switch v-model="aplicableAll" color="primary" inset hide-details class="mt-0 pt-0"></v-switch>
            </div>

            <!-- Selector de Agencias cuando no aplica a todas -->
            <v-expand-transition>
              <div v-if="!aplicableAll" class="mt-3 pt-3 border-top">
                <label class="form-label font-weight-medium text-caption text--secondary mb-1 d-block">
                  Agencias específicas con acceso <span class="text-danger">*</span>
                </label>
                <v-autocomplete v-model="accesso" :items="accessArray" item-value="id" item-text="text"
                  placeholder="Buscar y seleccionar agencias..." multiple chips small-chips deletable-chips outlined
                  dense :rules="!aplicableAll ? rules.accesso : []" hide-details="auto">
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3" small class="ma-1 font-weight-medium" color="blue lighten-5"
                      text-color="primary">
                      <span>{{ item.text || item.name }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text text-caption font-weight-medium ml-1">
                      (+{{ accesso.length - 3 }} más)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </v-expand-transition>
          </div>
        </v-col>

        <!-- Botones de Acción -->
        <v-col cols="12" class="pt-3">
          <v-divider class="mb-3"></v-divider>
          <div class="d-flex justify-end align-center">
            <v-btn outlined color="grey darken-1" class="mr-2 text-capitalize" @click="$emit('toggle', false)">
              <i class="lni lni-close mr-1"></i> Cancelar
            </v-btn>
            <v-btn color="primary" depressed class="text-capitalize px-5" type="submit">
              <i class="lni lni-checkmark mr-1"></i> {{ edit ? 'Actualizar' : 'Guardar' }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import Tarifario from "../../../clases/Tarifario.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "formAddTarifario",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: true,
    },
    accessArray: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
      Tarifario: Tarifario.getPropertyModel(),
      Id: "",
      Nombre: "",
      Segmento: "",
      Mercado: "",
      EsPrecioHotel: false,
      accesso: [],
      aplicableAll: false,
      type: "hotel",
      accesoCode: "",
      rules: {
        required: [
          (v) => !!v || "El campo es obligatorio",
        ],
        name: [
          (v) => !!v || "El nombre del tarifario es obligatorio",
          (v) => (v && v.trim().length >= 2) || "Debe tener al menos 2 caracteres",
        ],
        accesso: [
          (v) =>
            this.aplicableAll ||
            (Array.isArray(v) && v.length > 0) ||
            "Debe seleccionar al menos una agencia",
        ],
      },
    };
  },
  watch: {
    aplicableAll(val) {
      if (val && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    ...mapActions("TarifasStore", ["getMercadosReserva"]),
    checkForm(e) {
      if (e) e.preventDefault();
      if (this.$refs.form && this.$refs.form.validate()) {
        this.$emit("successData", {
          ...this.$data,
          Id: this.Id,
          Nombre: this.Nombre,
          aplicableAll: this.aplicableAll,
          Familia: this.Segmento || this.Familia,
          Segmento: this.Segmento,
          Mercado: this.Mercado,
          accesso: Array.isArray(this.accesso)
            ? this.accesso
            : this.accesso
              ? [this.accesso]
              : [],
        });
      }
    },
  },
  computed: {
    ...mapGetters("SegmentosReserva", {
      segmentosReserva: "getSegmentosReserva",
    }),
    ...mapGetters("TarifasStore", {
      mercadosReserva: "getMercadosReserva",
    }),
  },
  mounted() {
    this.getMercadosReserva();
    if (this.edit && this.dataEdit) {
      this.Id = this.dataEdit.Id || "";
      this.Nombre = this.dataEdit.Nombre || "";
      this.Segmento = this.dataEdit.Segmento || this.dataEdit.Familia || "";
      this.Mercado = this.dataEdit.Mercado || "";

      const accesos = Object.entries(this.dataEdit.Accesos || {});
      const dataAccesos = [];
      let fullAccess = false;

      accesos.forEach(([key]) => {
        if (key === "All") {
          fullAccess = true;
        } else {
          dataAccesos.push(key);
        }
      });

      this.aplicableAll = fullAccess;
      this.accesso = dataAccesos;
    }
  },
};
</script>

<style scoped>
.tarifario-form-wrapper {
  background: #ffffff;
}

.access-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
}

.border-top {
  border-top: 1px dashed #cbd5e1;
}

.form-label {
  font-size: 0.8125rem;
  color: #475569;
}
</style>
